import { render } from "./AddSong.vue?vue&type=template&id=48f237ca&scoped=true"
import script from "./AddSong.vue?vue&type=script&lang=js"
export * from "./AddSong.vue?vue&type=script&lang=js"

import "./AddSong.vue?vue&type=style&index=0&id=48f237ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48f237ca"

export default script